import React, { useRef, useState } from 'react'
import { checkTextTranslation, checkTranslation, getObject } from '../../utils/useful'
import inputComponents from '../inputs/inputComponents'
import tableComponents from '../tableComponents'
import ActionButton from './ActionButton'
import StageActionButton from './StageActionButton'


class TableRowAbsolute extends React.Component {


    state = {
        pinedIndex: 0
    }
    // componentDidUpdate(){

    // }
    // const row = useRef(null)


    // const indicatorMouseDown = (e) => {
    //     // pauseEvent(e)
    //     // if (e.stopPropagation) e.stopPropagation();
    //     // if (e.preventDefault) e.preventDefault();

    //     isDown = true
    //     document.addEventListener('mouseup', mouseUp)
    //     setTimeout(() => {
    //         cloneRow()
    //     }, 300);

    // }


    // const mouseUp = () => {
    //     isDown = false
    //     document.removeEventListener('mouseup', mouseUp)
    // }
    componentDidMount() {
        console.log('ssssssssssddd', this.props.data);
    }

    changeValue = (key, value, extra) => {

        console.log(key, value)

        let myFunction = null
        this.props.headers.forEach(header => {
            if (header.key == key && header.information?.changeFunction) {
                myFunction = header.information?.changeFunction
            }
        });
        if (!myFunction && this.props.changeValue) {
            this.props.changeValue(key, value, extra)
        }
        // console.log(myFunction)

        if (myFunction && this.props.functionsHandler) {
            this.props.functionsHandler({ function: myFunction }, key, value, extra)
        }
    }



    render() {

        return (

            <div ref={el => this.row = el} className="tableRow " style={{ width: this.props.widths['*'] }}>
                {/* <div className='flexcc'>
                    <StageActionButton />
                </div> */}






                {this.props.headers?.map((header, index) => {
                    // console.log('`0`0`0`', header)
                    if (header.showMain != false) {
                        let padding = null
                        let isSticky = false
                        if (index === 0 && Math.abs(this.props.scrollX) > 5) {
                            isSticky = true
                        }
                        let data = getObject(this.props.data, header.key)
                        // console.log(data)
                        let Component = tableComponents[header.type]
                        if (header?.information?.inplaceEditable) {
                            Component = inputComponents[header.type]
                        }

                        if (index == 0) {
                            padding = this.props.firstRowpadding ?? 0
                        }

                        return (
                            // <div className={"tableBodyItem flexc flex-row " + (header?.information?.inplaceEditable ? ' inplaceEditable ' : '') + (index == 0 ? ' firstTableBodyItem ' : '') + (isSticky ? ' stickytableBodyItem' : '')} key={header.key} style={{ zIndex: this.state.actionIsOpen ? 4 : (index == 0 ? 1 : 0), paddingLeft: padding, transition: 'all 0.3', flex: index == 0 ? '1 0' : '0 0', maxWidth: index == 0 ? null : this.props.widths[header.key], flexBasis: this.props.widths[header.key], width: this.props.widths[header.key] }}>

                            <div className={"tableBodyItem flexc flex-row " + (header?.information?.inplaceEditable ? ' inplaceEditable ' : '') + (index == 0 ? ' firstTableBodyItem ' : '') + (isSticky ? ' stickytableBodyItem' : '')} key={header.key} style={{ paddingLeft: padding, transition: 'all 0.3', flex: index == 0 ? '1 0' : '0 0', maxWidth: index == 0 ? null : this.props.widths[header.key], flexBasis: this.props.widths[header.key], width: this.props.widths[header.key] }}>
                                {index <= this.state.pinedIndex && (
                                    <div>
                                        {index == 0 && (
                                            <div className='mrd-3' style={{}}>
                                                <ActionButton onOpen={() => this.setState({ actionIsOpen: true })} onClose={() => { this.setState({ actionIsOpen: false }) }}>

                                                    <div className="  py-3 px-3 d-flex flex-column w-100" style={{ minWidth: 120, boxShadow: '0px 0px 30px #10101030', backgroundColor: '#fff', borderRadius: 6 }}>

                                                        {this.props.actions && Object.values(this.props.actions).map((prop, index) => {
                                                            return (
                                                                <button onClick={() => this.props.actionClicked(prop, this.props.data, this.props.index)} className="w-100 p-0 text-start flexcb mt-1" >
                                                                    <p className="text-small  ">{checkTranslation(prop.label)}</p>
                                                                    {/* <img src='/assets/icons/useful/text.svg' height={15} /> */}
                                                                </button>
                                                            )
                                                        })}

                                                    </div>
                                                </ActionButton>
                                            </div>

                                        )

                                        }
                                        <div className='component-container'>
                                            {
                                                Component && (
                                                    <Component data={data} header={header} fullData={this.props.data} changeValue={this.changeValue} extra={{ index: this.props.index, _id: this.props.id }} />
                                                )
                                            }

                                        </div>
                                    </div>
                                )}
                            </div>
                        )
                    }
                })}


                {/* {this.props.settings?.extendedActions && this.props.actions?.map((prop, index) => {
                    let isSticky = false

                    return (
                        <div className={"tableBodyItem " + (isSticky ? 'stickytableBodyItem' : '')} key={header.key} style={{ transition: 'all 0.3', flex: index == 0 ? '1 0' : '0 0', maxWidth: index == 0 ? null : this.props.widths[header.key], flexBasis: this.props.widths[prop.key] }}>
                            <p >{checkTranslation(this.props.data[prop.key])}</p>
                        </div>
                    )
                })} */}

                {/* {
                    !this.props.settings?.extendedActions && this.props.actions && (
                        <div className={"tableBodyItem px-3 py-1"} style={{ transition: 'all 0.3', flex: '0 0', maxWidth: this.props.widths['*actions'], flexBasis: this.props.widths['*actions'] }}>

                            <button onClick={() => this.props.openActionsModal(this.props.data, this.props.index)} style={{ background: '#677dc415', borderRadius: 20, padding: '4px 12px' }}>
                                <p className="text-smaller text-bold text-uppercase" style={{ color: '#677dc4aa' }}>{checkTranslation('{{lang}}actions')}</p>
                            </button>
                        </div>
                    )
                } */}

            </div >


        )
    }

}

export default TableRowAbsolute
